import React from 'react'
import Accordion from 'react-bootstrap/Accordion';
function FaqThree() {
  return (
    <div>
      <>
        {/* Tmp FAQ area Start  */}
        <div className="faq-area faq-style-one mb-5">
          <div className="container ">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head mb-0">
                  <div className="section-sub-title center-title">
                    <img
                      src="assets/images/services/section-custom-menubar.png "
                      alt="Corporate_service"
                    />
                    <h2 className="title split-collab">FAQ's</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row align-items-center g-5">
              <div className="col-lg-6 pr--30">
                <div className="thumbnail-faq-cons">
                  <img
                    src="assets/images/faq/faq.png"
                    alt="Business Consulting FAQ"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="faq-accordion">
                  <div className="faq-accordion">
                    <Accordion defaultActiveKey="0">
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          <div className="accordion-button-left">
                            <i className="fa-regular fa-question" />
                            <span>What is tax and legal advisory?</span>
                          </div>
                          <div className="accordion-button-right">
                            <i className="fa-sharp fa-light fa-arrow-right" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          Tax and Legal Advisers is a multi-functional team of
                          lawyers and accountants. We protect your business from
                          tax risks.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          <div className="accordion-button-left">
                            <i className="fa-regular fa-question" />
                            <span>What is company accounting?</span>
                          </div>
                          <div className="accordion-button-right">
                            <i className="fa-sharp fa-light fa-arrow-right" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          We keep your accounting books while you focus
                          attention on running your business and generating
                          profits.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>
                          <div className="accordion-button-left">
                            <i className="fa-regular fa-question" />
                            <span>What do you do for corporate clients?</span>
                          </div>
                          <div className="accordion-button-right">
                            <i className="fa-sharp fa-light fa-arrow-right" />
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          For corporate clients, we offer a strategic plan &
                          marketing analytics of the financial health and
                          business risks.
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>

                    <div className="faq-buttom">
                      <h4 className="title">Still Have More Questions?</h4>
                      <p>
                        Contact Our{" "}
                        <a style={{ color: "#89BAF5" }} href="/contact-us">
                          Expert Support Team
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Tmp FAQ area Start  */}
      </>
    </div>
  );
}

export default FaqThree